'use strict';

module.exports = ['$scope', '$timeout', '$location', 'OrderPlannerSvc', 'ForecastSvc', 'MaterialSvc', 'PlantSvc', 'ModalSvc', '$q', function ($scope, $timeout, $location, OrderPlannerSvc, ForecastSvc, MaterialSvc, PlantSvc, ModalSvc, $q) {
    var _this = this;
    // ------------------
    // Helper functions
    // ------------------
    function loadPlans() {
        OrderPlannerSvc.list($scope.$root.plant).success(function (plan_list) {
            _this.available_plans = plan_list;
        });
    }

    // ------------------
    // Events
    // ------------------
    function getParamsFromURL() {
        var search = $location.search();
        _this.plan_id = search.plan;
        _this.step = search.step || 'select_plan';
        _this.selected_table_view = search.table_view;
    }

    function setParamsToURL(step, plan, table_view) {
        $location.search('step', step);
        $location.search('plan', plan);
        $location.search('table_view', table_view);
    }

    function filterMaterials() {
        _this.filtered_materials = _this.all_materials.filter(function (item) {
            var plan_material_ids = _this.plan.materials.map(function (item) {
                return item.material_id;
            });

            return item.is_output_material && plan_material_ids.indexOf(item.id) == -1;
        });
    }

    $scope.$on("$locationChangeSuccess", function (e, url, oldUrl) {
        getParamsFromURL();
    });

    $scope.$on("$destroy", () => {
        setParamsToURL(undefined, undefined, undefined);
    });

    // ------------------
    // Watches
    // ------------------
    $scope.$watch(() => {
        return _this.plan_id
    }, function (newVal, oldVal) {

        if (!newVal) {
            _this.plan = null;
            return;
        }

        // Don't fetch the plan if it's already loaded
        if (!_this.plan || _this.plan_id != _this.plan.id) {
            OrderPlannerSvc.get($scope.plant, _this.plan_id).then((order_plan) => {
                _this.plan = order_plan;
                _this.selected_from_month = moment().startOf('month').month(0);

                _this.plan.save_changes = $scope.permissions.edit_order_plan;

                if (!_this.all_materials) {
                    MaterialSvc.list($scope.$root.plant).success(function (data) {
                        _this.all_materials = data;

                        filterMaterials();
                    });
                } else {
                    filterMaterials();
                }
            });
        }
    });

    $scope.$watch(() => {
        return _this.selected_table_view
    }, function (newVal, oldVal) {

        if (newVal != _this.table_view_options[2].value && _this.plan && _this.selected_table_view) {
            _this.startFromFilter(0);
            _this.selected_from_month = moment().startOf('month').month(0);
        }
    });

    $scope.$watch(() => {
        return _this.selected_from_month
    }, function (newVal, oldVal) {
        if (newVal) {
            _this.startFromFilter(newVal.month());
        }
    });

    $scope.$watchCollection(() => {
        if (_this.plan) {
            return _this.plan.materials.map((material_plan) => {
                return material_plan.expanded;
            });
        }
    }, function (newVal, oldVal) {
        if (newVal) {
            var materials_plan_count = _this.plan.materials.length;
            var expanded_materials_plan_count = 0;

            newVal.forEach((expanded) => {
                if (expanded) {
                    expanded_materials_plan_count++;
                }
            });

            _this.expandButtonText = materials_plan_count == expanded_materials_plan_count ? "Collapse All" : "Expand All";

        }
    });

    // ------------------
    // Scope functions
    // ------------------
    _this.addMaterial = function () {
        if (_this._new_material) {
            _this.plan.addMaterial(_this._new_material).then(() => {
                _this._new_material = '';
                filterMaterials();
            });
        }
    };

    _this.deleteMaterial = function (material_plan_id) {
        _this.plan.deleteMaterial(material_plan_id).then(() => {
            _this.plan.refreshData().then(() => {
                filterMaterials();
            });
        });
    };

    _this.deletePlan = function (plan) {

        ModalSvc.confirmationDialog.open({
            title: `Delete ${_this.plan.description }?`,
            message: `Are you sure you want to delete ${_this.plan.description }?`
        }).result.then(() => {
            _this.plan.delete().then(() => {
                setParamsToURL('select_plan');
                loadPlans();
            });
        });
    };

    _this.createNewPlan = function () {
        var year = _this.new_plan_year;
        var description = _this.new_plan_description;
        var json_data = {
            year: year,
            description: description
        };

        _this.new_plan_description = "Annual Plan";
        _this.new_plan_year = moment().year();

        OrderPlannerSvc.getNew($scope.plant, json_data).then((order_plan) => {
            order_plan.description = description;
            _this.plan = order_plan;
            setParamsToURL('historical');
        })
    };

    _this.savePercentages = function () {
        if (!_this.plan.id) {
            OrderPlannerSvc.create(_this.plan).then((order_plan) => {
                _this.plan = order_plan;
                setParamsToURL('forecast', order_plan.id, 'quantity');
            });
        } else {
            setParamsToURL('forecast', _this.plan_id, 'quantity');
        }
    };

    _this.loadPlan = (plan) => {
        setParamsToURL('forecast', plan.id, 'quantity');
    };

    _this.backToPlanList = () => {
        setParamsToURL('select_plan');
        loadPlans();
        _this.plan = null;
    };

    _this.editPercentages = function () {
        setParamsToURL('historical', _this.plan_id);
    };
    _this.editMaterials = function () {
        setParamsToURL('edit_materials', _this.plan_id);
    };

    _this.backToPlan = function () {
        setParamsToURL('forecast', _this.plan_id, 'quantity');
    };

    _this.hasAllEstimates = function () {
        for (var i = 0; i <= _this.materials.length - 1; i++) {
            if (!_this.materials[i].estimates) {
                return false;
            }
        }
        return true;
    };

    _this.selectTableView = function (value) {
        setParamsToURL('forecast', _this.plan_id, value);
        _this.plan.refreshLayout();
    };

    _this.isCurrentMonth = function (date) {
        return moment().startOf('month').isSame(date.startOf('month'));
    };

    _this.expandAll = function () {

        var materials_plan_count = _this.plan.materials.length;
        var expanded_materials_plan_count = 0;

        _this.plan.materials.forEach((material_plan, index) => {
            if (material_plan.expanded) {
                expanded_materials_plan_count++;
            }
        });

        if (materials_plan_count == expanded_materials_plan_count) {
            _this.plan.materials.forEach((material_plan, index) => {
                material_plan.expanded = false;
            });
        } else {
            _this.plan.materials.forEach((material_plan, index) => {
                material_plan.expanded = true;
            });
        }

        _this.plan.refreshLayout();
    };

    _this.materialPlanHasEstimations = function (material_plan) {

        if (material_plan.various.hasEstimates) {
            return true;
        }

        material_plan.entries.forEach((entry) => {
            if (entry.hasEstimates) {
                return true;
            }
        });

        return false;
    };

    _this.startFromFilter = function (month) {
        _this.startFromMonth = month;
        _this.plan.updateTotals(month);
    };

    _this.getCellVisibility = function (index) {
        var notSummaryView = _this.selected_table_view != _this.table_view_options[2].value;
        return notSummaryView || index >= _this.startFromMonth;
    };

    _this.getCellCount = function () {
        var notSummaryView = _this.selected_table_view != _this.table_view_options[2].value;
        return notSummaryView ? 12 : 12 - _this.startFromMonth;
    };

    _this.isMeasuredCell = function (index) {
        var notSummaryView = _this.selected_table_view != _this.table_view_options[2].value;

        return notSummaryView ? index == 0 : index == _this.startFromMonth;
    };

    // ------------------
    // Fetch Data
    // ------------------

    // get customers list
    PlantSvc.getCustomers($scope.$root.plant).success(function (data) {
        _this.customers = data;
    });

    loadPlans();

    // ------------------
    // nit
    // ------------------

    _this.expandButtonText = "Expand All";

    _this.plan = undefined;
    _this.materials = []; // TODO, remove?
    _this.customers = [];
    _this.available_plans = [];

    _this.startFromMonth = 0;

    // Plan creation form
    _this.new_plan_description = "Annual Plan";
    _this.new_plan_year = moment().year();

    //
    _this.table_view_options = [
        {value: 'quantity', label: 'Volume'},
        {value: 'price', label: 'Revenue'},
        {value: 'summary', label: 'Summary'}
    ];
    _this.selected_table_view = _this.table_view_options[0].value;

    _this.months = [];

    for (var i = 0; i < 12; i++) {
        _this.months.push(moment().startOf('month').month(i));
    }

    // ------------------
    // Initialization
    // ------------------
    _this.step = 'select_plan';
    _this.plan_id = undefined;

    getParamsFromURL();

}];